export default __webpack_public_path__ + "static/media/crit_fail_logo.e04e6ee9.png";